// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609110033/js/" + chunkId + "." + {"44":"a4394dcb","225":"c0d53c5d","481":"fcbeccea","486":"53300d42","770":"aff438fe"}[chunkId] + ".0.998319004491498.chunk.js";
};